
import { mapActions } from 'vuex'
export default {
  props: {
    wording: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    ...mapActions({
      vxResetAllSearch: 'search/resetAllSearch',
    }),
    doFilterReset() {
      this.vxResetAllSearch()
      const toggledDropdown = document.querySelector('.filter-dropdown.toggled')
      if (toggledDropdown) {
        toggledDropdown.click()
      }

      const toggledButton = document.querySelector('.filter-toggle.toggled')
      if (toggledButton) {
        toggledButton.click()
      }
    },
  },
}
